import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  inject,
} from '@angular/core';
import {
  provideRouter,
  TitleStrategy,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { apiRoutes } from '../environments/apis/api-routes';
import { localstorageTokensKeys } from '../environments/apis/tokens-keys';
import { environment } from '../environments/environment';
import {
  API_ROUTES,
  BASE_API_URL,
  LOCALSTORAGE_TOKENS,
} from './core/constants/injection-tokens';
import maridPreset from './core/helpers/theme';
import { interceptorProviders } from './core/interceptors';
import { ThemeService } from './core/services/theme.service';
import { TranslatedTitleStrategy } from './core/services/translated-title.strategy';
import { TranslationHelperService } from './core/services/translation-helper.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withEnabledBlockingInitialNavigation()),
    provideHttpClient(withInterceptors(interceptorProviders)),
    provideAnimationsAsync(),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
    }),
    ...provideTranslateHttpLoader({
      prefix: '/i18n/',
      suffix: '.json',
      useHttpBackend: true,
    }),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: maridPreset,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    MessageService,
    {
      provide: BASE_API_URL,
      useValue: environment.apiUrl,
    },
    {
      provide: API_ROUTES,
      useValue: apiRoutes,
    },
    {
      provide: LOCALSTORAGE_TOKENS,
      useValue: localstorageTokensKeys,
    },
    { provide: TitleStrategy, useClass: TranslatedTitleStrategy },
    provideAppInitializer(() => {
      const translation = inject(TranslationHelperService);
      inject(ThemeService).initTheme();
      return firstValueFrom(translation.initLang());
    }),
  ],
};
